document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.main-nav');
  if (menuButton && nav) {
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', () => {
      if (nav) nav.classList.remove('is-open');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
    });
  });
});


(function () {
  function showCardSlide(slider, index) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-card-slide]'));
    if (slides.length < 2) return;
    var next = (index + slides.length) % slides.length;
    var track = slider.querySelector('[data-card-track]');
    if (track) track.style.transform = 'translateX(-' + (next * 100) + '%)';
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === next);
    });
    slider.dataset.slideIndex = String(next);
    var counter = slider.querySelector('[data-card-current]');
    if (counter) counter.textContent = String(next + 1);
  }

  function shiftCardSlider(slider, direction) {
    var current = parseInt(slider.dataset.slideIndex || '0', 10);
    showCardSlide(slider, current + direction);
  }

  var autoSlideTimers = new WeakMap();

  document.addEventListener('mouseover', function (event) {
    var slider = event.target.closest('[data-card-slider][data-auto-slide="true"]');
    if (!slider || autoSlideTimers.has(slider)) return;
    var timer = setInterval(function () { shiftCardSlider(slider, 1); }, 2000);
    autoSlideTimers.set(slider, timer);
  }, true);

  document.addEventListener('mouseout', function (event) {
    var slider = event.target.closest('[data-card-slider][data-auto-slide="true"]');
    if (!slider) return;
    if (event.relatedTarget && slider.contains(event.relatedTarget)) return;
    var timer = autoSlideTimers.get(slider);
    if (timer) {
      clearInterval(timer);
      autoSlideTimers.delete(slider);
    }
    showCardSlide(slider, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var mediaLink = event.target.closest('.product-card__media-link');
    if (!mediaLink) return;
    var mediaSlider = mediaLink.closest('[data-card-slider]');
    if (mediaSlider && mediaSlider.dataset.preventCardClick === 'true') {
      event.preventDefault();
      event.stopPropagation();
      mediaSlider.dataset.preventCardClick = 'false';
    }
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var slider = event.target.closest('[data-card-slider]');
    if (!slider || event.target.closest('button')) return;
    slider.dataset.pointerStartX = String(event.clientX);
    slider.dataset.pointerMoved = 'false';
  }, true);

  document.addEventListener('pointermove', function (event) {
    var slider = event.target.closest('[data-card-slider]');
    if (!slider || slider.dataset.pointerStartX == null) return;
    if (Math.abs(event.clientX - parseFloat(slider.dataset.pointerStartX)) > 10) {
      slider.dataset.pointerMoved = 'true';
    }
  }, true);

  document.addEventListener('pointerup', function (event) {
    var slider = event.target.closest('[data-card-slider]');
    if (!slider || slider.dataset.pointerStartX == null) return;
    var diff = event.clientX - parseFloat(slider.dataset.pointerStartX);
    delete slider.dataset.pointerStartX;
    delete slider.dataset.pointerMoved;
    if (Math.abs(diff) > 40) {
      slider.dataset.preventCardClick = 'true';
      shiftCardSlider(slider, diff < 0 ? 1 : -1);
    }
  }, true);

  document.addEventListener('pointercancel', function (event) {
    var slider = event.target.closest('[data-card-slider]');
    if (!slider) return;
    delete slider.dataset.pointerStartX;
    delete slider.dataset.pointerMoved;
  }, true);
})();
